import React, { useMemo, useState } from "react";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import digitalFloraData from "../../data/digitalFloraData";

// Components
import HeroSection from "./FloraHome/HeroSection";
import StatsCards from "./FloraHome/StatsCards";
import SearchBar from "./FloraHome/SearchBar";
import PlantCard from "./FloraHome/PlantCard";
import EmptyState from "./FloraHome/EmptyState";

import {
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";

function DigitalFlora() {
  const [search, setSearch] = useState("");

  const filteredPlants = useMemo(() => {
    const text = (search || "").toLowerCase().trim();

    return digitalFloraData.filter((plant) => {
      const commonName = (plant?.common_name || "").toLowerCase();
      const scientificName = (plant?.scientific_name || "").toLowerCase();
      const localName = (plant?.local_name || "").toLowerCase();
      const family = (plant?.family || "").toLowerCase();

      return (
        commonName.includes(text) ||
        scientificName.includes(text) ||
        localName.includes(text) ||
        family.includes(text)
      );
    });
  }, [search]);

  return (
    <>
      <Navbar />

      <Box
        sx={{
          minHeight: "100vh",
          background:
            "linear-gradient(180deg,#F6FCF7 0%,#F9FDF9 45%,#FFFFFF 100%)",
          pb: 8,
        }}
      >
        <Container maxWidth="xl">
          {/* Hero */}
          <HeroSection />

          {/* Stats */}
          <Box sx={{ mt: 4, mb: 6 }}>
            <StatsCards
              plants={digitalFloraData}
              filteredPlants={filteredPlants}
            />
          </Box>

          {/* Search */}
          <Box sx={{ mb: 6 }}>
            <Typography
              align="center"
              sx={{
                color: "#0B3C5D",
                fontWeight: 700,
                fontSize: {
                  xs: "1.5rem",
                  md: "2rem",
                },
                mb: 1,
              }}
            >
              Search Plant Species
            </Typography>

            <Typography
              align="center"
              sx={{
                color: "text.secondary",
                mb: 4,
              }}
            >
              Search by Common Name, Scientific Name,
              Local Name or Botanical Family
            </Typography>

            <SearchBar
              search={search}
              setSearch={setSearch}
            />
          </Box>

          {/* Heading */}
          <Box
            sx={{
              textAlign: "center",
              mb: 5,
            }}
          >
            <Typography
              sx={{
                color: "#0B3C5D",
                fontWeight: 700,
                fontSize: {
                  xs: "2rem",
                  md: "2.5rem",
                },
              }}
            >
              Plant Collection
            </Typography>

            <Typography
              sx={{
                mt: 1,
                color: "text.secondary",
                maxWidth: 750,
                mx: "auto",
              }}
            >
              Browse the documented flora of Rayalaseema University
              including taxonomy, conservation status,
              medicinal importance and ecological significance.
            </Typography>
          </Box>

          {/* Plant Cards */}
          {filteredPlants.length > 0 ? (
            <Grid
              container
              spacing={4}
              justifyContent="center"
              alignItems="stretch"
            >
              {filteredPlants.map((plant, index) => (
                <Grid
                  item
                  key={plant?.id || index}
                  xs={12}
                  sm={6}
                  md={6}
                  lg={4}
                  xl={3}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: 420,
                    }}
                  >
                    <PlantCard plant={plant} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <EmptyState />
          )}
        </Container>
      </Box>

      <Footer />
    </>
  );
}

export default DigitalFlora;